import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Text } from '@landtrustinc/design-system';
import css from './InquiryFieldError.module.css';

/** One error style for the whole inquiry flow (dates, summary, submit errors). */
const InquiryFieldError = ({ children, className, ...rest }) => (
  <Text
    as="p"
    size="sm"
    fontWeight="bold"
    color="var(--text-error)"
    role="alert"
    className={classNames(css.root, className)}
    {...rest}
  >
    {children}
  </Text>
);

InquiryFieldError.defaultProps = { className: null };
InquiryFieldError.propTypes = { children: node.isRequired, className: string };

/** Wrap form fields so their app-wide ValidationError matches InquiryFieldError. */
export const inquiryFieldErrorsClassName = css.fieldErrors;

export default InquiryFieldError;
